import React from "react";
import { Form, FormGroup, Input } from "reactstrap";

class DropdownSelect extends React.Component {
  render() {
    const { category, serviceId, selected, employeeSelected } = this.props;
    // console.log("TCL: DropdownSelect -> render -> employeeSelected", employeeSelected);

    const optionValues = category
      ? category.map((element, index) => (
          <option key={`${element._id}${index}${serviceId}`} value={element._id}>
            {`${element.firstname} ${element.lastname}`}
          </option>
        ))
      : null;

    return (
      <Form>
        <FormGroup>
          <Input
            type="select"
            name={this.props.name}
            id="exampleSelect"
            // value={employeeSelected.length !== 0 ? employeeSelected[0]._id : null}
            onChange={event => this.props.handleChange(event)}
          >
            <option key={null} value={null} >
              Select an Employee
            </option>
            {selected ? (
              <option key="noPreference" value="noPreference">
                No Preference
              </option>
            ) : null}

            {optionValues}
          </Input>
        </FormGroup>
      </Form>
    );
  }
}

export default DropdownSelect;



// WEBPACK FOOTER //
// ./components/DropdownSelect2/index.js